






















import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import _ from 'lodash';
import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  authData: any = null;

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: '确认信息',
          content: '您确定要解绑吗？',
          onOk: async () => {
            if (!this.checkPermission('admin-stadium-bank')) {
              this.$message.error('没有[admin-stadium-bank]权限');
              return;
            }
            const res = await this.$store.dispatch('stadium/unbindweixin', {
              stadium_id: this.stadiumId,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              this.authData = null;
            } else {
              this.$message.error(res.Message);
            }
          },
        });
      }
    });
  }

  async loadDetail() {
    const res = await this.$store.dispatch('stadium/settingDetail', {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data && res.Data !== '{}') {
      // console.log(res.Data)
      if (res.Data.profit_mch && _.startsWith(res.Data.profit_mch, '{')) {
        this.authData = JSON.parse(res.Data.profit_mch);
      }
      // this.formData = res.Data
    }
  }

  mounted() {
    this.loadDetail();
  }
}
